import { Color, Flex, Spacing, Table, Text } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useTableData } from '../../hooks/useTableData'
import { AuditTrailAccountTable } from '../../types/AuditTrail'
import { AuditTrailTableRow } from '../../types/AuditTrailTableRow'
import { TableColumns } from '../TableColumns'
import * as Styled from './styles'

interface AuditTrailTableProps {
  data: AuditTrailAccountTable
  isRefetching?: boolean
}

export const AuditTrailTable = ({ data, isRefetching }: AuditTrailTableProps) => {
  const { t } = useTranslation()

  const { mainData, tableName, total, type } = data
  const columns = useMemo(() => TableColumns({ t, type }), [t, type])

  const tableData = useTableData({ data: mainData })

  const isTableLoading = isRefetching || !data

  return (
    <Styled.TableWrapper>
      <Flex flexDirection="column" gap={Spacing.S16}>
        <Text variant="bodyLG" weight="medium" color={Color.Grey800}>
          {tableName}
        </Text>
        <Table<AuditTrailTableRow>
          columns={columns}
          data={tableData}
          isLoading={isTableLoading}
          disabledRowsClickable
        />

        <Styled.FooterWrapper>
          <Text variant="bodyLG" weight="medium">
            {t('audit_trail.table.footer.total')}
          </Text>
          <Text variant="bodyLG" weight="medium">
            {total}
          </Text>
        </Styled.FooterWrapper>
      </Flex>
    </Styled.TableWrapper>
  )
}
